import styled from 'styled-components';

export const ButtonText = styled.span`
  text-transform: capitalize;
`;

export const FormContainer = styled.div`
  @media (min-width: 768px) {
    width: 65%;
    float: left;
  }
`;

export const SummaryContainer = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
    width: 35%;
    float: left;
    padding: 5px 0 0 10px;
    height: ${props => `${props.formHeight}px` || '100vh'};
  }
`;

export const InnerContainer = styled.div`
  @media (min-width: 768px) {
    position: sticky;
    top: 58px;
  }
`;
